import { useState } from 'react';
import { Row, Col, Spin, Tag } from 'antd';
import { CampaignFields } from '@copilot/common/store/models/redux';
import { useSelector } from 'react-redux';
import { getCampaignIcon } from '@copilot/common/utils/campaign';
import { CampaignMemberSelectors } from '@copilot/common/store/selectors/campaignMember';

interface CampaignSummaryHeaderProps {
    campaign: CampaignFields;
    //TODO: CPD-2267
    campaignNameUpdateHandler: (id: string, name: string) => Promise<void>;
}

const stopEventPropagation = (event: any) => event.stopPropagation();

function CampaignSummaryHeader({
    campaign,
    campaignNameUpdateHandler: _campaignNameUpdateHandler,
}: CampaignSummaryHeaderProps) {
    const campaignMembers = useSelector(CampaignMemberSelectors.getByCampaign(campaign.id));
    const [isUpdating, _] = useState<boolean>(false);

    return (
        <Row justify="space-between" align="middle">
            <Col>
                <Spin spinning={isUpdating}>
                    <Row align="top">
                        <Tag
                            color={campaign.primaryColour}
                            style={{
                                lineHeight: 0,
                                padding: '2px',
                                fontSize: '12px',
                                marginTop: '6px',
                                marginRight: '6px',
                            }}
                        >
                            {getCampaignIcon(campaign.type)}
                        </Tag>
                        <Col>
                            <h3>
                                <strong>{campaign.name}</strong>
                            </h3>
                            <span>{`Team Members: ${campaignMembers.length}`}</span>
                        </Col>
                    </Row>
                </Spin>
            </Col>
            <Col style={{ textAlign: 'center' }} onClick={stopEventPropagation}>
                <h4>Campaign Status:</h4>
                <Tag color={!!+campaign.status ? 'green' : 'red'}>
                    {!!+campaign.status ? 'Active' : 'Disabled'}
                </Tag>
            </Col>
        </Row>
    );
}

export default CampaignSummaryHeader;
